<section class="home-page-wrapper">
    <header class="header practitioner-home-header bottom-header-shade">
        <div class="Flexbox">
            <div class="header-content contnet-filters Flexbox Flexbox__flex-1 Flexbox__direction-rows fs5">

                <div class="header-title content-item Flexbox">
                    <span class="worklistTitle">{{worklistTitle}} </span>
                    <div class="Flexbox Flexbox_max_width_100 Flexbox__flex-1 Flexbox__just-end  Flexbox__box-align-center checkbox-custom-worklist">
                        <gen-test-actions [addTestAvailable]="!isUserAdmin()" *ngIf="showFilters"></gen-test-actions>
                        <gen-button *ngIf="showCreatePatientButton" (click)="createPatient()" [iconClass]="'icon__add new-patient-add-icon'" [text]="'Add new patient'"></gen-button>
                        <gen-export-worklist-data style="margin-right: 7.5rem" [exportButtonText]="'Export List'"></gen-export-worklist-data>

                        <input type="checkbox" id="checkBoxMyWorklist" name="selected" [(ngModel)]="displayMyWorklist" (click)="getAnalyses()" *ngIf="showFilters">
                        <label [ngClass]="{'enabled': displayMyWorklist}" for="checkBoxMyWorklist" *ngIf="showFilters"></label>
                    </div>
                </div>

                <div class="content-item Flexbox Spacebox__b-small">
                    <section class="worklist-filter-categories-wrapper" *ngIf="showFilters">
                        <div *ngFor="let category of categories; trackBy: trackCategory; let first=first">
                            <div id="{{getId(category)}}" class="filter-category  Flexbox Flexbox__direction-rows"
                                (click)="filterByCategory(category.categoryProperty)"
                                [ngClass]="{'active': selectedCategoryName == category.categoryProperty, 'filter-category-first' : first}">
                                <span style="font-size: 2.57rem;">{{category.count}}</span>
                                <span class="filter-category-caption">{{category.name | translate}}</span>
                            </div>
                        </div>
                    </section>
                    <div class="patient-search angucomplete-holder" id="test-search" style="position: relative; padding-top: 1.07rem;">
                        <gen-search-field placeholder="Search by" 
                                    [autoSearch]="true" 
                                    [value]="worklistSearchText" 
                                    [loading]="searchLoading" 
                                    [selfHandler]="false" 
                                    (clearEmit)="worklistSearchText = ''; filterByFreeText('');" 
                                    [removeExtraSpaces]="true"
                                    (searchEmit)="filterByFreeText($event)">
                        </gen-search-field>
                    </div>
                </div>

            </div>
        </div>
    </header>

    <section class="home-content home-content-flex Flexbox Flexbox__direction-rows">
        <gen-worklist class="worklist"
                    [searchText]="worklistSearchText"
                    [blockInitialLoad]="true"
                    (onSearchEnd)="updateLoadingStatus(!$event)"
                    [displayCheckableItems]="true"
                    [load]="loading">
        </gen-worklist>
    </section>
</section>